import { AreaDesignerManager } from '../areaDesignerManager';
import theme from 'src/shared/theme';
import { Tool } from '../helpers';
import { T } from 'src/shared/helpers';
import AreaDesignerPlugin from './areaDesignerPlugin';

export class AreaDesignerToolToolipPlugin implements AreaDesignerPlugin {
    private manager!: AreaDesignerManager;

    private layer!: paper.Layer;
    private label!: paper.Group;
    private text: string | null = null;

    public create = (manager: AreaDesignerManager) => {
        this.manager = manager;

        if (manager.mode == 'VIEWER') return;

        this.layer = new manager.paper.Layer();
        this.layer.bringToFront();

        this.label = new manager.paper.Group();
        this.label.applyMatrix = false;
        this.layer.addChild(this.label);
        this.createLabel(this.label);
    };

    private createLabel = (group: paper.Group) => {
        const rect = new this.manager.paper.Path.Rectangle(new this.manager.paper.Rectangle(0, 0, 70, 24), new this.manager.paper.Size(4, 4));
        rect.fillColor = new this.manager.paper.Color('#ffffff');
        rect.strokeScaling = false;
        rect.strokeWidth = 0.5;
        rect.strokeColor = new this.manager.paper.Color('#9ca3af');

        const text = new this.manager.paper.PointText(new this.manager.paper.Point(35, 16));
        text.content = '';
        text.fontSize = 11;
        text.fontWeight = 400;
        text.fontFamily = 'Inter, Montserrat, sans-serif';
        text.fillColor = new this.manager.paper.Color('#455a64');
        text.justification = 'center';

        group.addChildren([rect, text]);
    };

    private updateLabelPosition = (x: number, y: number) => {
        this.label.position = new this.manager.paper.Point(x, y - 40 / this.manager.paper.view.zoom);
    };

    private updateLabelSize = () => {
        const scale = 1 / this.manager.paper.view.zoom;
        this.label.scaling = new this.manager.paper.Point(scale, scale);
    };

    private updateLabelVisibility = () => {
        this.layer.visible = this.text !== null && this.manager.ppcm == 0;
    };

    private setLabelText = (text: string | null) => {
        this.text = text;

        if (text) (this.label.children[1] as paper.PointText).content = text;
    };

    onToolChanged = (prevTool: Tool, newTool: Tool) => {
        if (this.manager.mode == 'VIEWER') return;

        if (newTool === 'ruler') {
            this.setLabelText(T._('Ruler', 'Admin'));
        } else if (newTool == 'pan') {
            this.setLabelText(null);
        } else {
            this.setLabelText(T._('Shape', 'Admin'));
        }

        this.updateLabelVisibility();
        this.updateLabelSize();
    };

    onMouseMove = (e: paper.ToolEvent) => {
        if (this.manager.mode == 'VIEWER') return;

        this.updateLabelPosition(e.point.x, e.point.y);
    };

    onViewZoomChanged = () => {
        if (this.manager.mode == 'VIEWER') return;

        this.updateLabelSize();
    };

    onAreaCreating = () => {
        this.layer.visible = false;
    };

    onRulerDragging = () => {
        this.layer.visible = false;
    };
}
